module.exports = __webpack_public_path__ + "images/fa-js2025-instructor-ned-krastev-mobile.webp";